import { z } from "zod";

// this isn't very extensible (open/closed principal of SOLID)
// I think we're getting to the point where this can be just a string defined
export const NodeRole = z.enum([
  "activity",
  "activity-frame",
  "activity-group",
  "attribute",
  "boolean-attribute",
  "boolean-variable",
  "composable",
  "composable-invokable",
  "course",
  "evaluation",
  "evaluation-pattern",
  "evaluation-pattern-matcher",
  "evaluation-pattern-scoring",
  "insight-booster",
  "interlude",
  "interlude-content",
  "media",
  "module",
  "named-value",
  "number-attribute",
  "number-variable",
  "predicate",
  "predicate-general", // predicates that can be used anywhere
  "query-results",
  "question",
  "reference-variable",
  "scene",
  "service",
  "string-attribute",
  "string-variable",
  "unit",
  "unit-group",
  "variable",
]);

export type NodeRole = z.infer<typeof NodeRole>;
